<template>
  <div>
    <v-layout row justify-center>
      <v-dialog :value="show" persistent width="80%" scrollable>
        <v-card>
          <!-- Card title -->
          <v-card-title v-if="current_media_type">
            <div>
              <div class="title">
                {{$t('assets_linker.dialog.title.select',{
                media_type:$t(`rms.media.collection.${current_media_type}`)
                })}}
              </div>
              <div
                class="py-1 body-1 greyDarken1--text"
              >{{$t(`rms.media.collection.${current_media_type}.subtitle`)}}</div>
            </div>
            <v-spacer></v-spacer>
            <v-btn icon dark small @click="$emit('close')" color="grey" class="mx-0">
              <v-icon small>$vuetify.icons.rms_close</v-icon>
            </v-btn>
          </v-card-title>
          <br />
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  class="pt-0"
                  label="Search"
                  prepend-inner-icon="search"
                  v-model="search"
                  clearable
                  single-line
                  @click:clear="clearSearch"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 text-xs-right>
                <v-btn color="secondary" dark @click="uploadDropzone" class="mx-0">
                  <v-icon small>$vuetify.icons.rms_upload</v-icon>
                  {{$t('assets_manager.button.upload')}}
                </v-btn>
                <!-- FIXME: remove the condition
                  -- show only when router has griveupload
                  -- query
                -->
                <v-btn color="primary" v-if="mime_type!='image'" dark @click="uploadGDrive">
                  <v-icon small>$vuetify.icons.rms_upload</v-icon>
                  {{$t('assets_manager.button.gd_upload')}}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>

          <!-- Media list -->

          <v-card-text fill-height>
            <v-data-table
              style="height:100%"
              height="100%"
              :headers="headers"
              :items="filteredItems"
              item-key="name"
              select-all

              class="elevation-1"
            >
              <template v-slot:items="props">
                <td>
                  <v-checkbox
                    :input-value="isSelected(props.item.file_id)"
                    @change="toggleSelected(props.item.file_id)"
                    primary
                    hide-details
                  ></v-checkbox>
                </td>
                <td width="5%" class="pa-1 text-xs-center">
                  <v-img
                    width="60%"
                    v-if="props.item.thumb"
                    :src="props.item.thumb"
                  ></v-img>
                </td>
                <td width="30%" class="text-xs-right">{{ props.item.file_name }}</td>
                <td class="text-xs-left">{{ props.item.file_mimetype }}</td>
                <td class="text-xs-left">{{ props.item.size }}</td>
                <td class="text-xs-left">{{ props.item.created_at }}</td>
                <td class="text-xs-left">
                  <span v-if="props.item.is_uploaded_by_right_holder">
                    {{$t('film.media.uploaded_by.right_holder')}}
                  </span>
                  <span v-else>{{$t('film.media.uploaded_by.company_members')}}</span>
                </td>
                <td class="text-xs-left">
                  <v-btn
                    slot="activator"
                    icon
                    small
                    dark
                    @click="deleteMedia(props.item.file_id)"
                  >
                    <v-icon color="secondary"
                      >$vuetify.icons.rms_delete</v-icon
                    >
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
          <!-- Actions -->
          <v-card-actions class="px-3">
            <v-spacer></v-spacer>
            <span v-if="filteredItems.length && (selected_medias&&selected_medias.length)" class="success--text pa-2 font-weight-bold">
              (*Selected: {{selected_medias.length}})
            </span>
            <span v-else class="error--text pa-2 font-weight-bold">
              ({{$t('assets_linker.media.not.selected')}})
            </span>
            <v-btn
              color="lightteal"
              outline
              @click="addToSelectedAndClose()"
            >{{$t("btn.apply_and_save")}}</v-btn>
            <v-btn
              color="grey"
              outline
              @click="$emit('close')"
            >{{ $t("rms.button.assets_manager.media_editor.cancel")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <Uploader
      v-if="show_uploader"
      :show="show_uploader"
      :model="model"
      :model_type="model_type"
      :mime_type="mime_type"
      :collection="this.collection"
      :upload_type="upload_type"
      @close="show_uploader = false"
      @uploadedSuccessfully="afterSuccessfulUpload"
    ></Uploader>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import Uploader from "@/components/media/Uploader";
import i18n from "@/i18n";
export default {
  props: [
    "show",
    "current_media_type",
    "selected_medias",
    "max_selections",
    "mime_type",
    "model",
    "model_type",
    "collection"
  ],
  name: "AssetsLinker",
  components: {
    Uploader
  },
  data() {
    return {
      search: "",
      drawer: true,
      show_uploader: false,
      upload_type: null,
      selected:[],
      headers: [
        { text: 'Image', align: 'left', value: 'name'},
        { text: 'File name', value: 'file_name' },
        { text: 'Type', value: 'file_mimetype' },
        { text: 'Size', value: 'size' },
        { text: 'Uploaded at', value: 'carbs' },
        { text: 'Uploaded by', value: 'carbs' },
        { text: 'Action', value: 'iron' }
      ],
    };
  },

  methods: {
    async deleteMedia(media_id) {
      if (confirm(i18n.t("rms.alert.confirm.delete.media"))) {
        try {
          await this.$store.dispatch("files/delete", {
            id: media_id,
            model_type: this.model_type,
            model_id: this.model.id
          });
          await this.$store.dispatch("files/get", {
            model_type: "film",
            model_id: this.model.id
          });
          this.$store.dispatch("app/showMessage", {
            message: i18n.t("message.success.deleted"),
            color: this.DEFINES.SNACKBAR_SUCCESS_COLOR
          });
        } catch (error) {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error"
          });
        }
      }
    },

    uploadDropzone() {
      this.upload_type = "dropzone";
      this.show_uploader = true;
    },
    uploadGDrive() {
      this.upload_type = "gdriveUpload";
      this.show_uploader = true;
    },
    clearSearch() {
      this.search = "";
    },

    isSelected(id) {
      if (this.selected_medias) {
        return this.selected_medias.includes(id) ? true : false;
      }
    },
    toggleSelected(id) {
      //check is media selected or not
      var is_selected = this.selected_medias.includes(id);

      if (is_selected) {
        this.selected_medias.splice(this.selected_medias.indexOf(id), 1);
      } else {
        this.selected_medias = [];
        this.selected_medias.push(id);
      }
    },

    isMediaSelected(id){
      return this.selected_medias.includes(id);
    },

    addToSelectedAndClose() {
      this.$emit("updateMediaType", {
        selected: this.selected_medias
      });
      this.$emit("close");
    },

    afterSuccessfulUpload(response){
      this.toggleSelected(response.file_id)
    }
  },
  computed: {
    ...mapFields("files", {
      assets: "film.uploads"
    }),

    filtered_medias() {
      return (
        this.assets
          //Filter assets with mime type
          .filter(file => {
            return (
              this.mime_type != this.DEFINES.MIME_TYPE.IMAGE ||
              file.file_mimetype.startsWith(this.DEFINES.MIME_TYPE.IMAGE)
            );
          })
          .filter(file => {
            return (
              this.mime_type != this.DEFINES.MIME_TYPE.VIDEO ||
              file.file_mimetype.startsWith(this.DEFINES.MIME_TYPE.VIDEO) ||
              file.file_mimetype.startsWith(this.DEFINES.MIME_TYPE.APPLICATION)
            );
          })
      );
    },

    filteredItems() {
      return this.filtered_medias.filter(file => {
        if (!this.search) return this.filtered_medias;
        return file.file_name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  }
};
</script>
<style scoped>
.media_file_container {
  height: 90%;
  position: relative;
  width: 10%;
  background-color: #e2e2e2;
}
.scroll {
  overflow-y: auto;
}
.max_height100vh {
  max-height: 50vh;
}
.v-card--reveal {
  align-items: center;
  bottom: 0;
  left: 1px;
  justify-content: center;
  opacity: 0.5;
  position: absolute;
  width: 100%;
}

>>>.v-table__overflow {
    height:99.9%;
    max-height:99.9%;
    overflow-y: auto !important;
}
</style>


